import React from 'react'
import { $textPrimary } from '../../../../../styles/colors/semantics'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../../SimpleBlockContent'
import Img from '../../../../Img'
import CtaV2 from '../../../../CtaV2'
import HighlightedText from '../../../../Utils/HighlightedText'
import Text from '../../../../Text'

function HardwarePageShowcase({ titleHl, subtitleHl, cards, features }) {
  return (
    <>
      <div className="p-[5%] flex flex-col items-center">
        <div className="container flex flex-col gap-4">
          <div className="flex flex-col gap-4 mb-16">
            { <HighlightedText {...titleHl}/> }
            { <HighlightedText {...subtitleHl}/> }
          </div>
          <div className="grid md:grid-cols-2 gap-4">
            { renderSingleItemCard(cards[0], false, 'linear-gradient(0deg, #262626 0%, #393939 100%)', `${$textPrimary.dark}`) }
            { renderSingleItemCard(cards[1], false, 'linear-gradient(180deg, #262626 0%, #000 100%)', `${$textPrimary.dark}`) }
          </div>
          <div className="grid grid-cols-1 gap-4">
            { renderSingleItemCard(cards[2], true, '#000', `${$textPrimary.dark}`) }
          </div>
          <div className="grid md:grid-cols-2 gap-4">
            { renderSingleItemCard(cards[3], false, 'linear-gradient(180deg, #F4F4F4 0%, #C6C6C6 100%)', `${$textPrimary.light}`) }
            { renderSingleItemCard(cards[4], false, '#E0E0E0', `${$textPrimary.light}`) }
          </div>
          <div className="grid grid-cols-1 gap-4">
            { renderSingleItemCard(cards[5], false, '#E0E0E0', `${$textPrimary.light}`) }
          </div>
          {/* The Pro Formula + Lite Formula wheel cards were removed (Pro Formula
              discontinued; Lite Formula AU-only). Accessories — formerly cards[8] —
              is now the final card at cards[6]. */}
          <div className="grid grid-cols-1 gap-4">
            { renderSingleItemCard(cards[6], false, '#E0E0E0', `${$textPrimary.light}`) }
          </div>
        </div>
      </div>
      <section className="p-[5%] py-16 md:py-24 lg:py-28 flex flex-col items-center">
        <div className="container">
          <div className="mb-12 grid grid-cols-1 items-start gap-5 md:mb-18 md:grid-cols-1 md:gap-x-12 lg:mb-20 lg:gap-x-20">
            <div style={{ textAlign: 'center' }}>
              <Text type="heading-2">What you get with VRS® DirectForce®</Text>
            </div>
            <div />
          </div>
          <div className="grid grid-cols-1 items-start gap-y-12 md:gap-y-16 md:grid-cols-3 md:gap-x-8 lg:gap-x-16">
            {
              features.map(f => renderFeature(f))
            }
          </div>
        </div>
      </section>
    </>
  )
}

function renderFeature(feature) {
  return (
    <div>
      <div className="mb-5 md:mb-6">
        {
          feature.imageCs && feature.imageCs.image && (
            /* task #67: imageCs.image is now a ResolvedImage descriptor */
            <Img
              image={feature.imageCs.image}
              alt={feature.imageCs.alt}
              layout="responsive"
              objectFit="contain"
              className="size-16"
            />
          )
        }
      </div>
      <Text type="heading-6">{feature.title}</Text>
      <SimpleBlockContent blocks={feature.text}/>
    </div>
  )
}

function renderSingleItemCard(c, horizontal, background, color) {
  // Defensive: this layout indexes cards by position, so a shorter cards[]
  // (e.g. after a product is discontinued and its card removed) would otherwise
  // dereference `undefined` and 500 the whole hardware page. Render nothing.
  if (!c || !c.imageCs) return null
  if (horizontal) {
    return (
      <div className={`${styles.cardHorizontalLayout} flex`} style={{ background, color }}>
        <div className="order-1 xl:order-0 flex flex-col items-center justify-center gap-2 text-center xl:basis-1/2">
          <SimpleBlockContent blocks={c.title}/>
          <SimpleBlockContent blocks={c.subtitle}/>
          <SimpleBlockContent blocks={c.text}/>
          {
            c.ctasV2 && c.ctasV2.length && (
              <div className="flex gap-2 items-center justify-center mt-4">
                { c.ctasV2.map(((cta, i) => <CtaV2 {...cta} key={'cta-' + i}/>)) }
              </div>
            )
          }
        </div>
        {/* task #67 descriptor. layout="fill" + reserveSpace={false} + object-fit:contain
            so the portrait image is CONTAINED within the card's fixed 800px box (letterboxed,
            whole image) instead of responsive height:auto overflowing + clipping past
            overflow:hidden and leaving the centered blur placeholder showing as a ghost. */}
        <Img
          image={c.imageCs.image}
          alt={c.imageCs.alt}
          layout="fill"
          reserveSpace={false}
          objectFit="contain"
          className="order-0 xl:order-1 xl:basis-1/2 xl:h-full h-full"
        />
      </div>
    )
  } else {
    return (
      <div className={`${styles.cardVerticalLayout}${c.reverse ? ' ' + styles.cardVerticalReverse : ''} flex flex-col`} style={{ background, color }}>
        {/* task #67 descriptor. layout="fill" (reserveSpace default) reserves the image's
            OWN aspect-ratio box, so the foreground image and the blur placeholder share one
            box (no ghost/double) and the box hugs the image instead of stretching to the
            grid-stretched card height and clipping the top. */}
        <Img
          image={c.imageCs.image}
          alt={c.imageCs.alt}
          layout="fill"
          objectFit="contain"
          className={`order-${c.reverse ? 2 : 0}`}
        />
        <div className="flex flex-col max-w-md text-center gap-2">
          <SimpleBlockContent blocks={c.title}/>
          <SimpleBlockContent blocks={c.text}/>
          {
            c.ctasV2 && c.ctasV2.length && (
              <div className="flex gap-2 items-center justify-center mt-4">
                { c.ctasV2.map(((cta, i) => <CtaV2 {...cta} key={'cta-' + i}/>)) }
              </div>
            )
          }
        </div>
      </div>
    )
  }
}

export default HardwarePageShowcase
